<script>
import {
  warehouseMethods,
  inventoryMethods,
  inventoryReportsMethods,
} from '@state/helpers'
import { mapGetters } from 'vuex'
let _ = require('lodash')

export default {
  name: 'CardSelectWarehouse',
  components: {},
  data() {
    return {
      tableheaders: [
        { key: 'code', label: 'Código:', class: 'mw-100' },
        { key: 'description', label: 'Nombre:', class: 'mw-100' },
        { key: 'multi_ubication', label: 'Ubicaciones:', class: 'mw-100' },
        { key: 'company', label: 'Compañia:', class: 'mw-100' },
        { key: 'nit', label: 'NIT:', class: 'mw-100' },
      ],
    }
  },
  computed: {
    ...mapGetters({
      warehouse_selected: 'retina/warehouse/warehouse_selected',
      ubication_selected: 'retina/warehouse/ubication_selected',
      total_products_quantity: 'retina/inventory/total_products_quantity',
      loading_inventory: 'retina/inventory/loading_inventory',
      inventory: 'retina/inventory/inventory',
    }),
    // ubications() {
    //   return this.warehouse_selected ? this.warehouse_selected.ubications : []
    // },
  },
  methods: {
    ...warehouseMethods,
    ...inventoryMethods,
    ...inventoryReportsMethods,
    // allWarehouse() {
    //   this.setLoadingWarehouses(true)
    //   return this.fetchWarehouses('')
    //     .then((data) => {
    //       this.setWarehouses(data.results)
    //       this.setLoadingWarehouses(false)
    //     })
    //     .catch((error) => {
    //       this.$axios_error_noty(error, this)
    //       this.setWarehouses([])
    //       this.setLoadingWarehouses(false)
    //       return []
    //     })
    // },
    sumQuantityItems(items){
      let quantity = 0
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if ('batchs' in item){
          let subquantity = 0
          for (let b = 0; b < item.batchs.length; b++) {
            subquantity += item.batchs[b].quantity;
          }
          quantity += subquantity
        }
      }
      return quantity
    },
    removeInventoryFromPending(_item, _type, _batch, _serial){
      let context = this
      console.log("entra removeBatch", _type, _batch, _serial)
      let _inventory = _.cloneDeep(context.$store.getters['retina/inventory/inventory'])
      let _inve_item = _inventory.find( (i) => i.id_ext === _item.id_ext)
      if (!_inve_item) return
      let changed = false
      _inve_item.batchs.forEach(batch => {
        if (batch.batch === _batch.batch){
          if (_type === 'serial' && batch.serials.includes(_serial)){
            if (batch.serials.length === 1){
              // un solo serial, se elimina el lote completo del inventario, porque pasó a pendiente (completamente)
              if (_inve_item.batchs.length === 1){
                _inventory = _inventory.filter(x => x.id_ext !== _item.id_ext)
                changed = true
                console.warn("UPDATED! 1a")
              } else {
                const index = _inve_item.batchs.map(x => x.batch).indexOf(_batch.batch)
                if (index > -1) {
                  _inve_item.batchs.splice(index, 1)
                  batch.quantity -= 1
                  changed = true
                  console.warn("UPDATED! 1b")
                }
              }
            } else {
              const index = batch.serials.indexOf(_serial)
              if (index > -1) {
                batch.serials.splice(index, 1)
                batch.assurance.splice(index, 1)
                batch.quantity -= 1
                changed = true
                console.warn("UPDATED! 2")
              }
            }
          } else if(_type === 'batch'){
            console.warn("NOT UPDATED!", _batch, _serial, _item)
          } 
        }
      })
      if (changed){
        context.setInventory(_inventory)
        let _new_total = context.sumQuantityItems(_inventory)
        context.setTotalProducts(_inventory.length)
        context.setTotalProductsQuantity(_new_total)
        console.warn("UPDATED FINAL:", _new_total)
      }
    },
    async findInventoryByOption() {
      if (!Boolean(this.warehouse_selected)) return
      let query_format =
        '?warehouse=' + this.warehouse_selected.id + '&ubication='
      if (this.warehouse_selected.multi_ubication == 'Varias Ubicaciones')
        if (!Boolean(this.ubication_selected)) return
        else query_format += this.ubication_selected.id

      /* 
      Cargar pendientes 
      fetchPendingInventory
      */

      let pendings
      await this.fetchPendingInventory(
        '?warehouse__id_siesa=' +
          this.warehouse_selected.id +
          '&location__id_siesa=' +
          (this.ubication_selected ? this.ubication_selected.id : '')
      )
        .then((data) => {
          pendings = data
        })
        .catch((error) => {
          console.log("catching error:", error)
          this.$axios_error_noty(error, this)
        })
      

      this.setLoadingInventory(true)
      this.fetchInventory(query_format)
        .then((data) => {
          this.setWarehouseI(this.warehouse_selected)
          this.setUbicacionI(this.ubication_selected)
          this.setInventory(data.results)
          this.setTotalProductsQuantity(this.sumQuantityItems(data.results))
          this.setTotalProducts(data.count)
          this.setStock([])
          this.clearPending()
          this.setTotalStock(0)
          this.setTotalStockQuantity(0)
          this.setSpent([])
          this.setTotalSpent(0)
          this.setTotalSpentQuantity(0)
          this.setTotalPending(0)
          this.setLoadingInventory(false)
          this.setConsultWarehouse(false)
          this.enableInventoryCountMode()

          // omito en el inventario lo que ya esté en pendiente:
          /*if(pendings.results.length > 0) {
            pendings.results[0].pending_set.forEach((pending) => {
              let product = { ...pending.product, batchs: pending.batchs }
              console.info("PRODUCT:", product)
              if (this.inventory.find((i) => i.id_ext == product.id_ext)){
                console.info("- En inventario!", product.id_ext)
                product.batchs.forEach((batch) => {
                  console.info("-- foreach batch", batch)
                  if (batch.serials.length > 0) {

                    console.info("--- serials.length > 0")
                    batch.serials.forEach((serial, index) => {
                      console.info("----> to moveItemInInventoryToPendingSerial", product.id_ext, serial, index)
                      this.removeInventoryFromPending(product, 'serial', batch, serial)
                    })
                  }
                  else {
                      this.removeInventoryFromPending(product, 'batch', batch, null)
                  }
                })
              } else {
                console.info("- product not founded:", product.id_ext)
              }
            })
          }*/

          /*
          Movemos los productos de inventario a pendientes segun lo guardado en base de datos
          - item.item       :   el item de inventory 
          - item.serial     :   el serial escogido
          - item.batch      :   el lote al que pertenece el serial
          - item.assurance  :   el index del serial al que pertenece la fecha de garantía
          */


          if(pendings.results.length > 0) {
            pendings.results[0].pending_set.forEach((pending) => {
              let product = { ...pending.product, batchs: pending.batchs }
              console.info("PRODUCT:", product)
              if (this.inventory.find((i) => i.id_ext == product.id_ext)){
                console.info("- En inventario!", product.id_ext)
                product.batchs.forEach((batch) => {
                  console.info("-- foreach batch", batch)
                  if (batch.serials.length > 0) {

                    console.info("--- serials.length > 0")
                    batch.serials.forEach((serial, index) => {
                      console.info("----> to moveItemInInventoryToPendingSerial", product.id_ext, serial, index)
                      try {
                          this.moveItemInInventoryToPendingkBySerial({
                          item: this.inventory.find((i) => i.id_ext == product.id_ext),
                          batch: batch.batch,
                          assurance: index,
                          serial: serial,
                        }).then(()=> {
                          this.removeInventoryFromPending(product, 'serial', batch, serial)
                        })
                      } catch(error){
                        console.error("error!", error)
                      }
                    })
                  }
                  else {
                    console.info("----> to moveItemInventoryToPendingLote", product.id_ext, batch)
                    this.moveItemInInventoryToPendingByLote({
                      item: this.inventory.find((i) => i.id_ext == product.id_ext),
                      batch: batch.batch,
                      lot_quantity: batch.quantity,
                    }).then(()=> {
                      this.removeInventoryFromPending(product, 'batch', batch, null)
                    })
                  }
                  // console.log(product.name, product.id_ext1, product.batchs.length)
                  // console.log(batch.batch, batch.serials, batch.quantity)
                })
                // !Aquí: Eliminar item de inventario porque pasó a pendientes:
                // let _inv = this.inventory.filter((i) => i.id_ext !== product.id_ext)
                // this.setInventory(_inv)
                // this.setTotalProductsQuantity(this.sumQuantityItems(_inv))
                // this.setTotalProducts(_inv.length)
                // console.log("-----> NEW LENGTH: ", this.inventory.length, this.total_products_quantity, this.sumQuantityItems(_inv))
              } else {
                console.info("- product not founded:", product.id_ext)
              }
            })
          }

        })
        .catch((error) => {
          this.setLoadingInventory(false)
          console.log("catching error 152")
          this.$axios_error_noty(error, this)
        })
    },
    selectConsultWarehouseProccess() {
      this.setConsultWarehouse(false)
      this.setInventoryOnlineMode(true)
    },
    returnConsultWarehouse() {
      this.$store.dispatch('retina/warehouse/clearWarehouse')
      this.$store.dispatch('retina/warehouse/clearUbication')
      this.setInventoryOnlineMode(false)
      this.setConsultWarehouse(true)
    },
  },
  mounted() {
    // this.allWarehouse()
    this.select_warehouse = this.warehouse_selected
      ? this.warehouse_selected
      : {}
    this.select_ubication = this.ubication_selected
      ? this.ubication_selected
      : {}
  }
}
</script>

<template>
  <b-row>
    <b-col xs="12" sm="12" md="12" lg="6">
      <b-card no-body v-if="warehouse_selected" class="p-2 pb-0">
        <b-card-text>
            <div>
              <span class="text-primary font-weight-lighter">Lugar seleccionado:</span>
              <b-card-title title-tag="h4">{{ warehouse_selected.description }}</b-card-title>
              <b-card-sub-title class="mb-2 lead">
                <div v-if="ubication_selected">{{ ubication_selected.name }} <b-badge variant="primary">{{ warehouse_selected.code }}</b-badge></div>
                <div v-else><i class="fa fa-exclamation-triangle"></i> Seleccionar ubicación</div>
                
              </b-card-sub-title>
            </div>
            <b-button-group class="w-100 mb-2" v-if="ubication_selected">
              <b-button
                @click="returnConsultWarehouse()"
                variant="outline-danger"
                class="mr-1"
                style="max-width: 40px"
              >
                <i class="fas fa-times"></i>
              </b-button>
              <b-button
                @click="selectConsultWarehouseProccess()"
                variant="outline-secondary"
                class="mr-1"
              >
                <i class="fas fa-globe-americas"></i>
                Inventario Online
              </b-button>

              <b-button
                @click="findInventoryByOption()"
                variant="outline-info"
              >
                <div v-if="!loading_inventory">
                  <i class="fas fa-dolly-flatbed"></i>
                  Conteo de Inventario
                </div>
                <span
                  v-if="loading_inventory"
                  class="spinner-border spinner-border-sm"
                  role="status"
                >
                </span>
                <span v-if="loading_inventory"> Cargando ... </span>
              </b-button>
            </b-button-group>
        </b-card-text>
      </b-card>
    </b-col>
    <b-col xs="12" sm="12" md="12" lg="6">
      <Transition appear>
          <b-table
          v-if="ubication_selected"
          class="table-sm bg-white"
          stacked
          borderless
          outlined
          :fields="tableheaders"
          :items="[warehouse_selected]"
        >
          <template v-slot:cell(multi_ubication)="row">
            <div class="font-italic text-info">
              {{ row.item.multi_ubication }}
              <b-badge
                v-if="row.item.multi_ubication == 'Varias Ubicaciones'"
                variant="info"
              >
                {{ row.item.ubications.length }}
              </b-badge>
            </div>
          </template>
        </b-table>
      </Transition>
    </b-col>
  </b-row>
</template>
